// Reklamları yalnızca bu dosyadan yönetin.
//
// Kullanım seçenekleri:
// 1) Reklam ağı kodu: enabled: true yapıp html alanına etiketi yapıştırın.
// 2) Görsel + bağlantı: imageUrl ve href alanlarını doldurun.
// 3) Yazılı sponsorluk: title ve text alanlarını doldurun.
//
// Bir konumu kapatmak için enabled: false bırakmanız yeterli.

const emptyAd = {
  enabled: false,
  label: 'Ads',
  html: ``,
  href: '',
  imageUrl: '',
  imageAlt: '',
  title: '',
  text: '',
};

export const ads = {
  top: {
    ...emptyAd,
    enabled: false,
    html: ` `,
  },

  left: {
    ...emptyAd,
    enabled: true,
    html: ` `,
  },

  right: {
    ...emptyAd,
    enabled: true,
    html: ` `,
  },

  bottom: {
    ...emptyAd,
    enabled: true,
    html: ` `,
  },
};

export const isAdEnabled = (placement) => {
  const ad = ads[placement];
  const hasContent = Boolean(ad?.html?.trim() || ad?.imageUrl || ad?.title || ad?.text);
  return Boolean(ad?.enabled && hasContent);
};
